module.exports = __webpack_public_path__ + "img/pr-4.34aed7c3.png";